import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ index, kicker, title, children }) => (
  <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#1FD1FF] mb-3">{index} — {kicker}</p>
      <h2 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.85]">{title}</h2>
    </Reveal>
    {children && <Reveal delay={0.1}>{children}</Reveal>}
  </div>
);
